import Layout from '../views/Layout'

const route = {
  component: Layout,
  redirect: 'user',
  path: '/user',
  children: [{
    path: '/user',
    name: 'user',
    meta: { aliveName: 'user', title: '律师名片管理' },
    component: resolve => require(['@/views/user/index'], resolve)
  },
  {
    path: '/selfUser',
    name: 'selfUser',
    meta: { aliveName: 'selfUser', title: '名片信息管理' },
    component: resolve => require(['@/views/selfUser/index'], resolve)
  }
  ]
}
export default route



// WEBPACK FOOTER //
// ./src/router/user.js